<div class="pulse-kpi-card__header">
    <span class="pulse-kpi-card__label">{{ label() }}</span>
    @if (hint(); as hint) {
        <button
            type="button"
            class="pulse-kpi-card__help"
            [attr.aria-label]="hint"
            [ngbTooltip]="hint"
            container="body"
            placement="top"
            tooltipClass="pulse-tooltip--hint"
            (click)="$event.stopPropagation()"
        >
            <fa-icon [icon]="faCircleQuestion" aria-hidden="true" />
        </button>
    }
    @if (icon(); as icon) {
        <fa-icon class="pulse-kpi-card__icon" [icon]="icon" aria-hidden="true" />
    }
</div>
<div class="pulse-kpi-card__body">
    @if (loading()) {
        <span class="pulse-kpi-card__skeleton" aria-hidden="true"></span>
    } @else {
        <div class="pulse-kpi-card__metric">
            <div class="pulse-kpi-card__value">{{ shownValue() }}</div>
            @if (shownSuffix(); as suffix) {
                <span class="pulse-kpi-card__value-suffix">
                    <span class="pulse-kpi-card__value-suffix-word">{{ suffix.word }}</span>
                    <span>{{ suffix.value }}</span>
                </span>
            }
            @if (caption(); as caption) {
                <span class="pulse-kpi-card__caption">{{ caption }}</span>
            }
        </div>
        @if (badges().length > 0) {
            <div class="pulse-kpi-card__badges">
                @for (badge of badges(); track $index) {
                    <app-generic-badge [color]="badge.color" [label]="badge.label" size="md" />
                }
            </div>
        }
    }
</div>
@if (link(); as link) {
    @if (link.routerLink; as routerLink) {
        <a
            class="pulse-kpi-card__link"
            [routerLink]="routerLink"
            (click)="$event.stopPropagation()"
        >
            {{ link.label }}
        </a>
    } @else {
        <span class="pulse-kpi-card__link pulse-kpi-card__link--disabled" aria-disabled="true">
            {{ link.label }}
        </span>
    }
}
